import React, { createContext, useReducer, useContext } from 'react';
import { ICopOrder } from '../orderModel';
import { IReturn, IReturnQuery } from '../models';

export const ADD_VALID_ART = 'ADD_VALID_ART';
export const REMOVE_VALID_ART = 'REMOVE_VALID_ART';
export const SET_ORDER = 'SET_ORDER';
export const ADD_OR_UPDATE_RETURN = 'ADD_OR_UPDATE_RETURN';
export const REMOVE_RETURN = 'REMOVE_RETURN';
export const SET_RETURN_QUERY = 'SET_RETURN_QUERY';
export const RESET_STATE = 'RESET_STATE';

export type GlobalState = {
  currentOrder: ICopOrder | undefined;
  returns: IReturn[];
  returnQuery: IReturnQuery | undefined;
};

export const initialState: GlobalState = {
  currentOrder: undefined,
  returns: [],
  returnQuery: undefined,
};

export interface Action {
  type: string;
  payload: any;
}

export type Dispatch = (action: Action) => void;

function addOrUpdate(state: GlobalState, action: Action, type: string, identifier: string) {
  const found = state[type].find((item: any) => item[identifier] === action.payload[identifier]);
  if (!found) {
    return {
      ...state,
      [type]: [action.payload, ...state[type]],
    };
  }
  return Object.assign({}, state, {
    [type]: state[type].map((item: any) => {
      return item[identifier] === action.payload[identifier] ? action.payload : item;
    }),
  });
}

function reducer(state: GlobalState, action: Action): GlobalState {
  switch (action.type) {
    case ADD_OR_UPDATE_RETURN:
      return addOrUpdate(state, action, 'returns', 'rowNumber');
    case REMOVE_RETURN:
      return {
        ...state,
        returns: [...state.returns.filter((a) => a.rowNumber !== action.payload)],
      };
    case SET_ORDER:
      return {
        ...state,
        currentOrder: action.payload,
      };
    case SET_RETURN_QUERY:
      return {
        ...state,
        returnQuery: action.payload,
      };
    case RESET_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

export const GlobalStateContext = createContext<{
  state: GlobalState;
  dispatch: Dispatch;
}>({
  state: initialState,
  dispatch: () => {},
});

type ProviderProps = {
  children: React.ReactNode;
};

// const storageString = localStorage.getItem('globalState');
// const storageState = storageString ? JSON.parse(storageString) : undefined;

const GlobalStateProvider: React.FunctionComponent<ProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  // const [state, dispatch] = useReducer(reducer, storageState || initialState);

  const value = { state, dispatch };

  // Offline mode to store in localStorage
  //   useEffect(() => {
  //     localStorage.setItem('globalState', JSON.stringify(state));
  //   }, [state])

  return <GlobalStateContext.Provider value={value}>{children}</GlobalStateContext.Provider>;
};

export const useGlobalStateValue = () => useContext(GlobalStateContext);

export default GlobalStateProvider;
